export const PATIENT_APP_LINK = 'https://chaika.com/app/store';
